<template>
    <v-card :height="height"
            flat>
        <div v-if="!disabled"
             class="panel-body no-padding">
            <div class="dragdrop-filters-container">
                <filter-autocomplete v-model="filters.name.value"
                                     :items="namesWithUserEntered"
                                     :placeholder="t_search"
                                     style="min-width: 64px"
                                     @update:userEnteredItems="userEnteredItemsMap.name = $event" />
                <filter-autocomplete v-model="filters.tags.value"
                                     :items="tagsWithUserEntered"
                                     :placeholder="t_tags"
                                     super-tags
                                     @update:userEnteredItems="userEnteredItemsMap.tags = $event" />
                <v-select-custom
                    v-model="sortOption"
                    :items="sortOptionList"
                    :aria-label="t_sort_by"
                    inline
                    style="flex-basis: 60px; flex-grow: 0">
                    <!--suppress VueUnrecognizedSlot -->
                    <template #selection="{item}">
                        <div class="dragdrop-sort-selection-container">
                            <i :class="[item.text[0]]" />
                            <i :class="[item.text[1]]" />
                        </div>
                    </template>
                    <!--suppress VueUnrecognizedSlot -->
                    <template #item="{item}">
                        <div class="dragdrop-sort-selection-container">
                            <i :class="[item.text[0]]" />
                            <i :class="[item.text[1]]" />
                        </div>
                    </template>
                </v-select-custom>
            </div>
            <div :style="{height: `${listHeight}px`}" class="scrollBox">
                <campaign-list :add="permissionAdd"
                               :campaigns="sortedEntries"
                               :element-class="elementsPerRowClass"
                               classes="no-padding">
                </campaign-list>
            </div>
        </div>
    </v-card>
</template>

<script>
import dndTabItemMixin from '../../../../mixins/dndTabItemMixin';
import campaignList from '../../campaign/list.vue';
import { sortElementList } from '../../../../../utils/publish';
import FilterAutocomplete from '../table/filter-autocomplete.vue';
import CampaignService from '../../../../services/CampaignService';

export default {
    components: {
        FilterAutocomplete,
        campaignList
    },
    mixins: [
        dndTabItemMixin
    ],
    data() {
        return {
            campaignService: new CampaignService(),

            /** @type {Record.<string, {matchMode: string, value: string[], num?: true, fieldName?: string}>} */
            filters: {
                name: {
                    matchMode: 'containsArray_OR',
                    value: []
                },
                tags: {
                    matchMode: 'arrayContainsNameArray_OR',
                    value: []
                }
            },

            /** Used by entriesLoaderMixin.js */
            t_data_load_error: Lang.langGet('Failed to load campaigns!')
        };
    },
    computed: {
        sortedEntries() {
            /* Shallow copy array with 'slice' to create new instance, 'sort'
             * modifies the array in-place and would not work properly on a
             * computed property. This is also much more readable. */
            return sortElementList(this.renderedEntries.slice(), 'name', this.sortOption);
        },
        /** Used by dndTabItemMixin.js */
        localStorageKeyDndSortOption() {
            return `dnd-sort-campaigns-${Laravel.activeProject}`;
        }
    },
    methods: {
        loadCampaigns() {
            return this.loadEntries(() => this.campaignService.getCampaigns(false, true));
        },
        refreshLocalCampaigns() {
            return this.loadEntries(this.entries);
        }
    },
    created() {
        this.loadCampaigns();
    }
};
</script>
